import {HelperItemType} from "../../Helper/HelperItem/types";
import {ContentPeerTargetType} from "../../Content/PeerTarget/types";
import {PeerActivityType} from "../../Content/PeerActivity/types";
import {DataSetOrderType} from "../../Main/common";
export enum StatPeerActivityContentActionTypes {
    API_RESPONSE_SUCCESS = "@@statPeerActivity/API_RESPONSE_SUCCESS",
    API_RESPONSE_ERROR = "@@statPeerActivity/API_RESPONSE_ERROR",
    GET_STAT_ACTIVITY_TILES = "@@statPeerActivity/GET_STAT_ACTIVITY_TILES",
    GET_STAT_ACTIVITY_ACTIVITIES_DATA = "@@statPeerActivity/GET_STAT_ACTIVITY_ACTIVITIES_DATA",
    GET_STAT_ACTIVITY_ENGAGEMENTS_DATA = "@@statPeerActivity/GET_STAT_ACTIVITY_ENGAGEMENTS_DATA",
    GET_STAT_ACTIVITY_TARGETS = "@@statPeerActivity/GET_STAT_ACTIVITY_TARGETS",
    GET_ACTIVITY = "@@statPeerActivity/GET_ACTIVITY",
    SET_PERIOD = "@@statPeerActivity/SET_PERIOD",
}

export interface StatPeerActivityState {
    tiles: Array<StatPeerActivityTileType>
    activitiesData: Array<StatPeerActivityActivitiesDataType>,
    engagementsData: Array<StatPeerActivityActivitiesDataType>,
    targets: Array<ContentPeerTargetType>,
    // Reaction breakdown of the post ({TYPE: count}); null when the network does not provide it.
    reactions?: StatPeerActivityReactionsType | null,
    // false when the channel reports it has no post statistics (all tile figures are null).
    statsAvailable?: boolean | null,
    activity?: PeerActivityType,
    periodFrom: number,
    selectedDate?: number,
    periodTo?: number,
    deltaDays?: number,
    eTagActivities?: string,
    isStatPeerActivityContentFetched:boolean
    isStatPeerActivityContentTargetFetched:boolean
}

export interface StatPeerActivityTileType{
  label?: string;
  value?: StatPeerActivityTileValueType
  helperItem?: HelperItemType
}

// null = no stored value (unavailable / not yet available), never drawn as 0.
export interface StatPeerActivityTileValueType{
    last?: number | null,
    first?: number | null,
    current?: number,
}

export type StatPeerActivityReactionsType = Record<string, number>;

export interface StatPeerActivityPayloadType{
    activity: PeerActivityType
    periodFrom?: number,
    periodTo?: number,
    limit?: number,
    order?: DataSetOrderType
}

// One point per day. `views`/`likes`/… are running totals, `<metric>Change` the day's
// change; a value that is not stored is left out of the point.
export interface StatPeerActivityActivitiesDataType{
    views?: number,
    comments?: number;
    likes?: number,
    reposts?: number,
    reach?: number,
    viewsChange?: number,
    commentsChange?: number,
    likesChange?: number,
    repostsChange?: number,
    reachChange?: number,
    erPost?: number,
    erView?: number,
    loveRate?: number,
    talkRate?: number,
    date?: string
}

